module.exports = __webpack_public_path__ + "img/form-2.1e49c3d.webp";